/**
 * HQ 홈페이지 상담 신청 서비스 (2026-10-27, 대표 전용 — 백엔드에서 hq_admin 게이트).
 * newattend.com 상담 신청서 → backend/api/public_consultation.py → 이 화면.
 */
import hqApi from './hqApiClient';

export type ConsultationStatus = 'new' | 'contacted' | 'done';

export interface Consultation {
  id: string;
  inquiry_type: string;
  name: string;
  phone: string;
  phone_verified?: boolean; // 카톡 인증번호로 확인한 연락처 (2026-10-27 밤~)
  phone_verified_at?: string | null;
  email: string | null;
  region: string | null;
  store_name: string | null;
  seat_count: number | null;
  message: string | null;
  privacy_version: string;
  privacy_agreed_at: string | null;
  client_ip: string | null;
  source_page: string | null;
  status: ConsultationStatus;
  staff_memo: string | null;
  handled_by_name: string | null;
  handled_at: string | null;
  created_at: string | null;
}

export interface ConsultationList {
  counts: Record<ConsultationStatus, number>;
  items: Consultation[];
}

const BASE = '/api/v1/hq/consultations';

const hqConsultationService = {
  async list(status?: ConsultationStatus): Promise<ConsultationList> {
    const { data } = await hqApi.get<ConsultationList>(BASE, { params: status ? { status } : {} });
    return data;
  },
  async newCount(): Promise<number> {
    const { data } = await hqApi.get<{ count: number }>(`${BASE}/new-count`);
    return data.count;
  },
  async update(id: string, body: { status?: ConsultationStatus; staff_memo?: string }): Promise<Consultation> {
    const { data } = await hqApi.patch<Consultation>(`${BASE}/${id}`, body);
    return data;
  },
};

export default hqConsultationService;
